import { AbstractControl, ValidatorFn } from '@angular/forms';

export function passportValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null;

    const valid = /^[A-Z0-9]{6,9}$/i.test(value);

    return valid ? null : { invalidPassport: true };
  };
}
